<script setup lang="ts">
const dayjs = useDayjs()
const { t } = useI18n()

const props = defineProps<{
  start?: string
  end?: string
  local?: boolean
}>()

const { start, end, local } = toRefs(props)

// main
const todayDate = computed(() =>
  local.value ? dayjs().utc().local() : dayjs().utc()
)
const startDate = computed(() => {
  if (!start?.value) return null
  return local.value
    ? dayjs(start.value).utc().local()
    : dayjs(start.value).utc()
})
const endDate = computed(() => {
  if (!end?.value) return null
  return local.value ? dayjs(end.value).utc().local() : dayjs(end.value).utc()
})

// utils
const isSameDay = computed(() => {
  if (!startDate.value || !endDate.value) return false
  return startDate.value.isSame(endDate.value, 'day')
})
const isToday = computed(() => todayDate.value.isSame(startDate.value, 'day'))

// formats
const startTime = computed(() => {
  if (!startDate.value) return ''
  return startDate.value.format('LT')
})
const endTime = computed(() => {
  if (!endDate.value) return ''
  return endDate.value.format('LT')
})
const startDay = computed(() => {
  if (!startDate.value) return ''
  return startDate.value.format('LL')
})
const endDay = computed(() => {
  if (!endDate.value) return ''
  return endDate.value.format('LL')
})
</script>

<template>
  <template v-if="isSameDay">
    <div class="flex flex-wrap">
      <UiDateTime :value="start" v-if="start">
        {{ isToday ? t('today') : startDay }}
        <span class="px-1">⋅</span>
        {{ startTime }}
      </UiDateTime>
      <template v-if="end">
        <span class="date-dash"></span>
        <UiDateTime :value="end">{{ endTime }}</UiDateTime>
      </template>
      <span class="mx-1">{{ local ? '' : 'UTC' }}</span>
    </div>
  </template>

  <template v-else>
    <div class="flex flex-wrap">
      <UiDateTime v-if="start" :value="start"
        >{{ startDay }}, {{ startTime }}</UiDateTime
      >
      <template v-if="end">
        <span class="date-dash"></span>
        <UiDateTime :value="end"
          >{{ endDay }}, {{ endTime }}</UiDateTime
        ></template
      >
      <span class="mx-1">{{ local ? '' : 'UTC' }}</span>
    </div>
  </template>
</template>

<style scoped>
.date-dash:after {
  content: '\2013';
  @apply mx-1;
}
</style>
